export default "__VITE_PUBLIC_ASSET__dfff5229__"